import { Base, Component, Watch } from '@/vue-property-decorator'
import { Bind } from '@/utils/Decorator'
import { GlobalEventActions } from '@/context/events'
import { GlobalEvents } from '@/context'
import { MusicItem } from '@/api/aside/type'
import { audioRef, changeMusic, getStorageIds, playMusic } from '../../utils'
import { useMainStore } from '@/store/index'
import { useMusicStore } from '../../store'

@Component<MusicAudio>({
  name: 'MusicAudio'
})
export default class MusicAudio extends Base {
  musicStore = useMusicStore()

  audioElement = audioRef()

  mainStore = useMainStore()

  @Watch('musicStore.sysMusicList', { immediate: true })
  protected async onMusicListDataUpdate() {
    const { autoplay, updateMyMusicList, sysMusicList } = this.musicStore

    const storageIds = getStorageIds()
    let myList: MusicItem[] = []

    if (storageIds.length > 0) {
      myList = sysMusicList.filter((item) => storageIds.includes(item.id))
    }
    //自动收藏一首，方便用户点击播放按钮能开始下载
    if (!myList.length && sysMusicList.length) {
      myList.push({ ...sysMusicList[0] })
    }
    updateMyMusicList(myList)

    this.$nextTick(() => {
      if (autoplay) {
        playMusic()
      } else {
        // 非自动播放模式，手动初始化播放状态为false
        this.musicStore.musicPlay = false
      }
    })
  }

  @Watch('mainStore.language', { immediate: true })
  async languageKeyChange() {
    this.musicStore.updateSysMusicList()
  }

  mounted() {
    GlobalEvents.subscribe(this.onVisibilityChange)
    this.$once('hook:beforeDestroy', () => {
      GlobalEvents.unsubscribe(this.onVisibilityChange)
    })
  }

  @Bind()
  private onVisibilityChange(actions: GlobalEventActions) {
    if (actions.type === 'PAGE_VISIBILITY_CHANGE') {
      const audioElement = audioRef()
      if (actions.payload.visibility) {
        const { musicPlay } = this.musicStore
        if (musicPlay) {
          audioElement.play()
        }
      } else {
        audioElement.pause()
      }
    }
  }

  private onLoadedMetadata(e: Event) {
    const audio = e.target as HTMLAudioElement
    // 获取音乐时长
    useMusicStore().totalTime = Math.ceil(audio.duration)
  }

  private onTimeUpdate(e: Event) {
    if (this.musicStore.progressMouseDown) return
    const audio = e.target as HTMLAudioElement
    this.musicStore.currentTime = Math.ceil(audio.currentTime)
  }

  private onEnded() {
    changeMusic(true, false).then(() => {
      this.$nextTick(() => {
        const audioElement = audioRef()
        audioElement.play()
      })
    })
  }

  render() {
    const { myMusicList, currentMusicIndex } = useMusicStore()
    const curMusicSrc = myMusicList[currentMusicIndex]?.oss_url || ''

    return (
      <audio
        id="musicAudio"
        src={curMusicSrc}
        preload="none"
        onLoadedmetadata={this.onLoadedMetadata}
        onTimeupdate={this.onTimeUpdate}
        onEnded={this.onEnded}
      >
        您的浏览器不支持。
      </audio>
    )
  }
}
